import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';

// The host's `resolveCoinSalesMode` (host/src/shared/domain/business/coin-sales.ts),
// read from the same /feature-flag and /admin/business answers: with the
// transition on, any `coinSales` value means coin sales are over for this
// business, and nobody may switch a gift card campaign back on (TWISM-20488).
export const isCoinSalesLocked = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  return !!(
    flags.includes(flagKeys.myProgramsCatalogTransition) &&
    business &&
    business.coinSales !== undefined
  );
};
